import { SAAS_URL_FILTER, CAMPUS, SAAS_DNS_FILTER } from '@core/constants/products.constant';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';

export type NavigationTreeType = 'primary' | 'secondary' | 'footer';

export interface NavigationItem {
  label: string;
  route: string;
  icon?: string;
  products: string[];
  onMenu?: boolean;
  children?: NavigationItem[];
}

export type NavigationBranch = NavigationItem[];
export type NavigationTree = NavigationBranch[];

export const navigationTree: NavigationTree = [
  [
    { label: 'trust-center', icon: 'insights', route: 'trust-center', products: [SAAS_URL_FILTER, CAMPUS, SAAS_DNS_FILTER],  onMenu: true,
      children: [
        { label: 'overview', route: 'trust-center/overview', products: [SAAS_URL_FILTER, CAMPUS, SAAS_DNS_FILTER], onMenu: true },
        { label: 'statistics', route: 'trust-center/statistics', products: [SAAS_URL_FILTER, SAAS_DNS_FILTER], onMenu: true }
      ]},
  ],
  [
    { label: 'swg', icon: 'security', route: 'swg', products: [SAAS_URL_FILTER, SAAS_DNS_FILTER],  onMenu: true,
      children: [
        { label: 'urls', route: 'swg/filtering-policies', products: [SAAS_URL_FILTER, SAAS_DNS_FILTER],  onMenu: true },
        { label: 'safe-search', route: 'swg/safe-search', products: [SAAS_DNS_FILTER],  onMenu: true },
        { label: 'awareness-pages', route: 'swg/awareness-pages', products: [SAAS_URL_FILTER], onMenu: true },
        { label: 'charters', route: 'swg/charters', products: [SAAS_URL_FILTER], onMenu: true },
        { label: 'decryption', route: 'swg/decryption', products: [SAAS_URL_FILTER],  onMenu: true },
        { label: 'antivirus', route: 'swg/antivirus', products: [SAAS_URL_FILTER],  onMenu: true },
        { label: 'filter_cat',route: 'swg/filtering-categories', products: [SAAS_URL_FILTER, SAAS_DNS_FILTER],  onMenu: true }
      ]
    },
    { label: 'casb', icon: 'cloud_done', route: 'casb', products: [SAAS_URL_FILTER, SAAS_DNS_FILTER], onMenu: true,
      children: [
        { label: 'detection', route: 'casb/detection', products: [SAAS_URL_FILTER, SAAS_DNS_FILTER], onMenu: true },
        // { label: 'governance', route: 'casb/governance', products: [SAAS_URL_FILTER], onMenu: true }
      ]
    }
  ],
  [
    { label: 'tools', icon: 'widgets', route: 'tools', products: [SAAS_URL_FILTER, SAAS_DNS_FILTER], onMenu: true,
      children: [
        { label: 'diagnostics', route: 'tools/diagnostics', products: [SAAS_URL_FILTER, SAAS_DNS_FILTER],  onMenu: true },
        { label: 'logs', route: 'tools/logs', products: [SAAS_URL_FILTER, SAAS_DNS_FILTER],  onMenu: true },
        { label: 'url-tester', route: 'tools/url-tester', products: [SAAS_URL_FILTER, SAAS_DNS_FILTER],  onMenu: true },
        { label: 'in-app-request', route: 'tools/in-app-request', products: [SAAS_URL_FILTER, SAAS_DNS_FILTER],  onMenu: true },
        { label: 'create-export', route: 'tools/logs/create-export', products: [SAAS_URL_FILTER, SAAS_DNS_FILTER],  onMenu: false },
      ]
    },
    { label: 'configuration', icon: 'settings', route: 'configuration', products: [SAAS_URL_FILTER, CAMPUS, SAAS_DNS_FILTER], onMenu: true,
      children: [
        { label: 'sync-directories', route: 'configuration/sync-directories', products: [SAAS_URL_FILTER, CAMPUS, SAAS_DNS_FILTER], onMenu: true },
        { label: 'proxy-pac-lists', route: 'configuration/proxypacs', products: [SAAS_URL_FILTER, SAAS_DNS_FILTER],  onMenu: true },
        { label: 'domain-lists', route: 'configuration/domain-lists', products: [SAAS_URL_FILTER, SAAS_DNS_FILTER],  onMenu: true },
        { label: 'schedules', route: 'configuration/schedules', products: [SAAS_URL_FILTER, SAAS_DNS_FILTER],  onMenu: true },
        { label: 'global-parameters', route: 'configuration/global-parameters', products: [SAAS_URL_FILTER, SAAS_DNS_FILTER],  onMenu: true },
        { label: 'connectors', route: 'configuration/log-connector', products: [SAAS_URL_FILTER],  onMenu: true },
      ]
    },
    { label: 'admin-menu', icon: 'manage_accounts', route: 'administration', products: [SAAS_URL_FILTER, SAAS_DNS_FILTER],  onMenu: true,
      children: [
        {label: 'administrator', route: 'administration/administrators', products: [SAAS_URL_FILTER, SAAS_DNS_FILTER],  onMenu: true },
        {label: 'admin-logs', route: 'administration/admin-logs', products: [SAAS_URL_FILTER, SAAS_DNS_FILTER],  onMenu: true },
      ]
    },
  ]
];

function isNavBranch(item: NavigationTree | NavigationBranch): item is NavigationBranch {
  return !Array.isArray(item[0]);
}

export function getFullNavTree(): Observable<NavigationTree> {
  return of(navigationTree);
}

export function findRouteByLabel(label: string, entries: NavigationTree | NavigationBranch = navigationTree): string[] {
  return isNavBranch(entries) ? entries.map(e => {
                                  return e.label === label ? e.route : e.children && e.children.length > 0 ? findRouteByLabel(label, e.children) : undefined
                                }).filter((val): val is string => !!val).flat()
                              : entries.map((branch: NavigationBranch) => findRouteByLabel(label, branch)).flat();
}

